/**
 * Strips the tags from a string, and also removes non-breaking spaces,
 * returning only the visible text content or an empty string.
 *
 * @param input - string to be checked and updated
 * @returns - updated or original string with tags and &nbsp; removed
 */
export function stripTags(input: string): string {
    if (!input) {
        return input;
    }
    const htmlRegexG = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
    // Remove tags
    let result = input.replace(htmlRegexG, '');

    /*
     * We have to insert a space in order not to lose any empty tags
     * But we don't want to show the space to the user so they are removed here
     */
    result = result.replace(/\u00A0|&nbsp;/g, ' ');

    return result;
}
